import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { LegsShapeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import {
    allConcretes,
    allMetals,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './common/materialGroups';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import { tableTrayShapeDimension } from './common/fieldsTrayShapeDimension';
import { allLegs, getLegsWithExceptions } from './common/shapesGroups';
import fieldsLegsDimension from './common/fieldsLegsDimension';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const tableConcreteForm: IForm = {
    formId       : PublishedFormId.TableConcrete,
    type         : FormTypeId.Table,
    thumbnailURL : '/resized-images/forms/tableConcrete.jpg',
    imagesURLs   : [
        '/resized-images/forms/description/tableConcrete/tableConcrete1.jpg',
        '/resized-images/forms/description/tableConcrete/tableConcrete2.jpg',
        '/resized-images/forms/description/tableConcrete/tableConcrete3.jpg',
        '/resized-images/forms/description/tableConcrete/tableConcrete4.jpg',
        '/resized-images/forms/description/tableConcrete/tableConcrete5.jpg',
    ],
    fieldsOrder: [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.TrayShapeDimension,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.LegsShape,
        IFormFieldKey.LegsMaterial,
        IFormFieldKey.LegsDimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        trayShapeDimension : tableTrayShapeDimension,
        trayMaterial       : {
            material: {
                value    : undefined,
                options  : allConcretes,
                required : true,
            },
        },
        legsShape: {
            value   : undefined,
            options : getLegsWithExceptions(allLegs,
                [
                    LegsShapeId.LegsMonastery,
                    LegsShapeId.LegsRightCrossPiece,
                    LegsShapeId.LegsSquareCrossPiece,
                    LegsShapeId.LegsTrestleCross,
                ]),
            required: true,
        },
        legsMaterial: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allSolidWoods,
                        ...allMetals,
                        ...allConcretes,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Garapa,
                        MaterialId.SheetMetal,
                        MaterialId.Zinc,
                    ],
                ),
                required: true,
            },
        },
        legsDimension  : fieldsLegsDimension,
        additionalData : additionalDataFactory({
            budgetMin          : 1200,
            budgetMax          : 13000,
            budgetDefaultValue : 2500,
            marks              : budgetMarksBuilder(1200, 100, 6000, 500, 13000),
        }),
        contact: fieldsContact,
    },
};

export default tableConcreteForm;
